<template>
  <div
    class="study-card"
    :class="[{ 'study-card--active': active }]"
    @click="handleClick"
  >
    <div class="study-card__footer">
      <span class="study-card__title">{{ title }}</span>
      <span class="study-card__deadline" :class="deadlineClass">
        <template v-if="deadlinePassed">
          <font-awesome-icon icon="calendar-times" />
          Critique deadline has passed
        </template>
        <template v-else
          ><app-date prepend="Deadline" :date="deadline"
        /></template>
      </span>
    </div>
  </div>
</template>

<script>
import AppDate from '@/components/app/AppDate';

export default {
  name: 'study-card',
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    deadline: {
      type: String,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { AppDate },
  methods: {
    handleClick() {
      this.$router.push({ name: 'art-club-study', params: { id: this.id } });
    },
  },

  computed: {
    deadlinePassed() {
      return new Date(this.deadline).getTime() < new Date().getTime();
    },
    deadlineClass() {
      const timeLeft = new Date(this.deadline).getTime() - new Date().getTime();
      let className = '';

      if (timeLeft <= 0) {
        className = '';
      } else if (timeLeft >= 1000 * 60 * 60 * 24 * 3) {
        className = 'green';
      } else if (
        timeLeft > 1000 * 60 * 60 * 24 * 1 &&
        timeLeft < 1000 * 60 * 60 * 24 * 3
      ) {
        className = 'orange';
      } else {
        className = 'red';
      }

      return className;
    },
  },
};
</script>

<style lang="scss" scoped>
.study-card {
  background: color('background', 'light');
  box-shadow: 0 2px 8px 0 rgba(59, 80, 94, 0.1);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  border: 1px solid color('grey');
  flex: 1;
  cursor: pointer;

  &--active {
    border-color: color('primary');
  }

  &__footer {
    display: flex;
    flex-direction: column;
  }

  &__title {
    text-align: center;
    font-size: calc-font-size(32);
    margin-bottom: 1.5rem;
  }

  &__deadline {
    color: color('text', 'light');
    font-size: 1rem;

    &.green {
      font-weight: 500;
      color: color('denotive', 'success');
    }

    &.orange {
      font-weight: 500;
      color: color('denotive', 'warning');
    }

    &.red {
      font-weight: 500;
      color: color('denotive', 'error');
    }
  }
}
</style>
